import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import {
  dropdownsSelectors,
  DropdownsState
} from "../../../features/dropdowns/state";
import State from "../../models/ParentUiState";

function getDropdownsState(state: State): DropdownsState {
  return state.dropdowns;
}

export const getSelectedChildInitialised: (state: State) => boolean =
  composeSelector(
    getDropdownsState,
    dropdownsSelectors.getSelectedChildInitialised
  );

// @ts-ignore
export const getChildUserId: (state: State) => string = composeSelector(
  getDropdownsState,
  dropdownsSelectors.getChildUserId
);

// @ts-ignore
export const getStartTime: (state: State) => string = composeSelector(
  getDropdownsState,
  dropdownsSelectors.getStartTime
);

// @ts-ignore
export const getEndTime: (state: State) => string = composeSelector(
  getDropdownsState,
  dropdownsSelectors.getEndTime
);

export const isCustomPeriod: (state: State) => boolean = composeSelector(
  getDropdownsState,
  dropdownsSelectors.isCustomPeriod
);
